export const AUTORS = "publishers";
export const SUBSCRIPTION_COMPANY = "campaigns/names";
export const DPO = "districts";
export const MONTH_VALID = "editions/subscription-type";
export const THEMATIC_CATALOG = "thematic-catalogs";
export const THEMATIC_CATALOG_REFS = "thematic-catalogs/group";

export const OFFICES = "offices/import";

export const EDIT_PAGE_VERSIONS = "page-versions-cms";
export const POST_PAGE_VERSIONS = new RegExp("pages/\\d+/page-versions");
export const RICHTEXT_EDITOR = "richtext-editor";
